// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { OccViewer } from "../viewer/viewer.js";
/**
 * This enumeration defines selection schemes supported by [[SelectionManager]].
 * It represents a subset of values of corresponding C++ `AIS_SelectionScheme` enumeration defined by OCCT.
 *
 * For using this enum please use its implementation from [[OccViewer.AIS_SelectionScheme]].
 */
export var AIS_SelectionScheme;
(function (AIS_SelectionScheme) {
    /** Undefined scheme, `AIS_SelectionScheme_UNKNOWN`. */
    AIS_SelectionScheme[AIS_SelectionScheme["UNKNOWN"] = 0] = "UNKNOWN";
    /** Clears current selection and select detected objects, `AIS_SelectionScheme_Replace`. */
    AIS_SelectionScheme[AIS_SelectionScheme["Replace"] = 1] = "Replace";
    /** Adds detected object to current selection, `AIS_SelectionScheme_Add`. */
    AIS_SelectionScheme[AIS_SelectionScheme["Add"] = 2] = "Add";
    /** Removes detected object from the current selection, `AIS_SelectionScheme_Remove`. */
    AIS_SelectionScheme[AIS_SelectionScheme["Remove"] = 3] = "Remove";
    /** Performs XOR for detected objects, other selected not touched, `AIS_SelectionScheme_XOR`. */
    AIS_SelectionScheme[AIS_SelectionScheme["XOR"] = 4] = "XOR";
    /** Clears current selection, `AIS_SelectionScheme_Clear`. */
    AIS_SelectionScheme[AIS_SelectionScheme["Clear"] = 5] = "Clear";
    /**
     * `Replace` with one difference: if result of replace is an empty and current selection
     * contains detected element, it will be selected (`AIS_SelectionScheme_ReplaceExtra`).
     */
    AIS_SelectionScheme[AIS_SelectionScheme["ReplaceExtra"] = 6] = "ReplaceExtra";
})(AIS_SelectionScheme || (AIS_SelectionScheme = {}));
/**
 * Update [[SelectionManager]] in OccViewer.
 * @internal
 */
OccViewer.onInit((theModule) => {
    const aSelectionManager = theModule.selectionManager;
    Object.defineProperty(aSelectionManager, "selectedObjectList", {
        get: function () { return theModule.interactiveContext.splitObjectId(this.selectedObjects); },
        set: function (theValue) { this.selectedObjects = theModule.interactiveContext.joinObjectIdList(theValue); },
    });
    Object.defineProperty(aSelectionManager, "selectionFilterList", {
        get: function () { return theModule.interactiveContext.splitObjectId(this.selectionFilter); },
        set: function (theValue) { this.selectionFilter = theModule.interactiveContext.joinObjectIdList(theValue); },
    });
    aSelectionManager.resetSelectionFilter = function () { this.selectionFilter = "*"; };
    aSelectionManager.getSelectionScheme = function () {
        //@ts-ignore
        const anInp = this._cppGetSelectionScheme();
        const aRet = [];
        for (let i = 0; i < anInp.size(); i++) {
            aRet.push(anInp.get(i));
        }
        return aRet;
    };
    aSelectionManager.setSelectionScheme = function (theParams) {
        // create a wrapper of c++ vector
        let aVect = new theModule["VectorWasmSelectionParams"]();
        for (let i = 0; i < theParams.length; i++) {
            aVect.push_back(theParams[i]);
        }
        //@ts-ignore
        this._cppSetSelectionScheme(aVect);
        // free allocated memory
        aVect.delete();
    };
    aSelectionManager.clearSelection = function (theToUpdate) {
        this.selectedObjects = "";
        if (theToUpdate) {
            theModule.updateView();
        }
    };
});
